<script lang="ts" setup>
defineProps<{ showHeight: number }>()

// Scrolling
const { pageRef } = useCustomerModulePage()
const { y } = useScroll(pageRef)
</script>

<template>
  <ClientOnly>
    <div
      class="fixed opacity-0 top-0 w-full bg-primary-800 z-10 transition-all"
      :class="{ 'opacity-100 top-16': y >= showHeight }"
    >
      <div class="PagePadding py-3 flex items-center justify-between">
        <slot />
      </div>
    </div>
  </ClientOnly>
</template>
